var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5217 2.04004H3.47788C2.66183 2.04004 2 2.67923 2 3.46721V20.5333C2 21.3213 2.66183 21.9597 3.47788 21.9597H20.5217C21.3386 21.9597 21.9996 21.3205 21.9996 20.5333V3.46721C21.9996 2.67923 21.3378 2.04004 20.5217 2.04004ZM8.07779 18.7101H5.08508V9.74229H8.07779V18.7101ZM6.58224 8.51831H6.56296C5.55816 8.51831 4.90918 7.82953 4.90918 6.96874C4.90918 6.08876 5.57824 5.41917 6.60232 5.41917C7.62559 5.41917 8.2561 6.08876 8.27538 6.96874C8.27538 7.82953 7.62559 8.51831 6.58224 8.51831ZM18.8696 18.7101H15.8768V13.9134C15.8768 12.7078 15.4439 11.8854 14.3612 11.8854C13.5339 11.8854 13.0416 12.4398 12.8255 12.9758C12.7468 13.167 12.7267 13.4358 12.7267 13.703V18.7109H9.73399C9.73399 18.7109 9.77334 10.5847 9.73399 9.74309H12.7267V11.0127C13.1243 10.4015 13.8367 9.53269 15.4238 9.53269C17.3925 9.53269 18.8687 10.8143 18.8687 13.5686V18.7101H18.8696Z",
    fill: "#006699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.9598c90949004beeffe8986eab7b887d.svg";
export { ForwardRef as ReactComponent };